/* lua.js generated code undefined */

// 掉落干预的配置（具体值会从meta中读取并覆盖）
let SchemeConfig = table(
    [1, "Scheme_Week", table(
        [1, "id", 0],
        [1, "dcName", "drop1"],
        [1, "description", "Week"],
        [1, "priority", 0],
        [1, "probability", 0],
        [1, "dropPort", table([1, "single", table([1, "m", 0], [1, "n", 0])], [1, "global", table([1, "m", 0], [1, "n", 0])])]
    )],
    [1, "Scheme_Normal", table(
        [1, "id", 1],
        [1, "dcName", "drop2"],
        [1, "description", "Normal"],
        [1, "priority", 0],
        [1, "probability", 0],
        [1, "dropPort", table([1, "single", table([1, "m", 0], [1, "n", 0])], [1, "global", table([1, "m", 0], [1, "n", 0])])]
    )],
    [1, "Scheme_Strong", table(
        [1, "id", 2],
        [1, "dcName", "drop3"],
        [1, "description", "Strong"],
        [1, "priority", 0],
        [1, "probability", 0],
        [1, "dropPort", table([1, "single", table([1, "m", 0], [1, "n", 0])], [1, "global", table([1, "m", 0], [1, "n", 0])])]
    )],
    [1, "Scheme_fuuu", table(
        [1, "id", 3],
        [1, "dcName", "fuuu"],
        [1, "description", "fuuu"],
        [1, "priority", 0],
        [1, "probability", 0],
        [1, "dropPort", table([1, "single", table([1, "m", 0], [1, "n", 0])], [1, "global", table([1, "m", 0], [1, "n", 0])])],
        [1, "fuuu", table(
            [1, "expectRatio", 0],
            [1, "stopTargetNum", table(
                [1, "kOrder", 0],
                [1, "kIce", 0],
                [1, "kBoss", 0],
                [1, "kWaterDig", 0],
                [1, "kFish", 0],
                [1, "kBlockCollection", 0],
                [1, "kPursue", 0]
            )],
            [1, "stopLeftSteps", 0],
            [1, "reduceExpectNum", 0],
            [1, "reduceNum", table(
                [1, "kOrder", 0],
                [1, "kIce", 0],
                [1, "kBoss", 0],
                [1, "kWaterDig", 0],
                [1, "kFish", 0],
                [1, "kBlockCollection", 0],
                [1, "kPursue", 0]
            )]
        )]
    )],
    [1, "Scheme_Extreme", table(
        [1, "id", 4],
        [1, "dcName", "drop4"],
        [1, "description", "extreme"],
        [1, "priority", 0],
        [1, "probability", 0],
        [1, "dropPort", table([1, "single", table([1, "m", 0], [1, "n", 0])], [1, "global", table([1, "m", 0], [1, "n", 0])])]
    )],
    [1, "Scheme_fuuu_strong", table(
        [1, "id", 5],
        [1, "dcName", "fuuu_strong"],
        [1, "description", "fuuu_strong"],
        [1, "priority", 0],
        [1, "probability", 0],
        [1, "dropPort", table([1, "single", table([1, "m", 0], [1, "n", 0])], [1, "global", table([1, "m", 0], [1, "n", 0])])],
        [1, "fuuu", table(
            [1, "expectRatio", 0],
            [1, "stopTargetNum", table(
                [1, "kOrder", 0],
                [1, "kIce", 0],
                [1, "kBoss", 0],
                [1, "kWaterDig", 0],
                [1, "kFish", 0],
                [1, "kBlockCollection", 0],
                [1, "kPursue", 0]
            )],
            [1, "stopLeftSteps", 0],
            [1, "reduceExpectNum", 0],
            [1, "reduceNum", table(
                [1, "kOrder", 0],
                [1, "kIce", 0],
                [1, "kBoss", 0],
                [1, "kWaterDig", 0],
                [1, "kFish", 0],
                [1, "kBlockCollection", 0],
                [1, "kPursue", 0]
            )]
        )]
    )],
    [1, "Scheme_fuuu_counterV2", table(
        [1, "id", 6],
        [1, "dcName", "fuuu_counterV2"],
        [1, "description", "fuuu_counterV2"],
        [1, "priority", 0],
        [1, "probability", 0],
        [1, "dropPort", table([1, "single", table([1, "m", 0], [1, "n", 0])], [1, "global", table([1, "m", 0], [1, "n", 0])])],
        [1, "fuuu", table(
            [1, "expectRatio", 0],
            [1, "stopTargetNum", table(
                [1, "kOrder", 0],
                [1, "kIce", 0],
                [1, "kBoss", 0],
                [1, "kWaterDig", 0],
                [1, "kFish", 0],
                [1, "kBlockCollection", 0],
                [1, "kPursue", 0]
            )],
            [1, "stopLeftSteps", 0],
            [1, "reduceExpectNum", 0],
            [1, "reduceNum", table(
                [1, "kOrder", 0],
                [1, "kIce", 0],
                [1, "kBoss", 0],
                [1, "kWaterDig", 0],
                [1, "kFish", 0],
                [1, "kBlockCollection", 0],
                [1, "kPursue", 0]
            )]
        )]
    )],
    [1, "Scheme_fuuu_strong_counterV2", table(
        [1, "id", 7],
        [1, "dcName", "fuuu_strong_counterV2"],
        [1, "description", "fuuu_strong_counterV2"],
        [1, "priority", 0],
        [1, "probability", 0],
        [1, "dropPort", table([1, "single", table([1, "m", 0], [1, "n", 0])], [1, "global", table([1, "m", 0], [1, "n", 0])])],
        [1, "fuuu", table(
            [1, "expectRatio", 0],
            [1, "stopTargetNum", table(
                [1, "kOrder", 0],
                [1, "kIce", 0],
                [1, "kBoss", 0],
                [1, "kWaterDig", 0],
                [1, "kFish", 0],
                [1, "kBlockCollection", 0],
                [1, "kPursue", 0]
            )],
            [1, "stopLeftSteps", 0],
            [1, "reduceExpectNum", 0],
            [1, "reduceNum", table(
                [1, "kOrder", 0],
                [1, "kIce", 0],
                [1, "kBoss", 0],
                [1, "kWaterDig", 0],
                [1, "kFish", 0],
                [1, "kBlockCollection", 0],
                [1, "kPursue", 0]
            )]
        )]
    )],
    [1, "Scheme_fuuu_negative", table(
        [1, "id", 8],
        [1, "dcName", "fuuu_negative"],
        [1, "description", "fuuu_negative"],
        [1, "priority", 0],
        [1, "probability", 0],
        [1, "dropPort", table([1, "single", table([1, "m", 0], [1, "n", 0])], [1, "global", table([1, "m", 0], [1, "n", 0])])],
        [1, "fuuu", table(
            [1, "expectRatio", 0],
            [1, "stopTargetNum", table(
                [1, "kOrder", 0],
                [1, "kIce", 0],
                [1, "kBoss", 0],
                [1, "kWaterDig", 0],
                [1, "kFish", 0],
                [1, "kBlockCollection", 0],
                [1, "kPursue", 0]
            )],
            [1, "stopLeftSteps", 0],
            [1, "reduceExpectNum", 0],
            [1, "reduceNum", table(
                [1, "kOrder", 0],
                [1, "kIce", 0],
                [1, "kBoss", 0],
                [1, "kWaterDig", 0],
                [1, "kFish", 0],
                [1, "kBlockCollection", 0],
                [1, "kPursue", 0]
            )]
        )]
    )],
    [1, "Scheme_fuuu_balance", table(
        [1, "id", 9],
        [1, "dcName", "fuuu_balance"],
        [1, "description", "fuuu_balance"],
        [1, "priority", 0],
        [1, "negative", table(
            [1, "probability", 0],
            [1, "reduceExpectNum", 0],
            [1, "finishReduceExpectNum", 0],
            [1, "dropPort", table([1, "single", table([1, "m", 0], [1, "n", 0])], [1, "global", table([1, "m", 0], [1, "n", 0])])]
        )],
        [1, "positive", table(
            [1, "probability", 0],
            [1, "reduceExpectNum", 0],
            [1, "finishReduceExpectNum", 0],
            [1, "dropPort", table([1, "single", table([1, "m", 0], [1, "n", 0])], [1, "global", table([1, "m", 0], [1, "n", 0])])]
        )],
        [1, "fuuu", table(
            [1, "expectRatio", 0],
            [1, "stopTargetNum", table(
                [1, "kOrder", 0],
                [1, "kIce", 0],
                [1, "kBoss", 0],
                [1, "kWaterDig", 0],
                [1, "kFish", 0],
                [1, "kBlockCollection", 0],
                [1, "kPursue", 0]
            )],
            [1, "stopLeftSteps", 0],
            [1, "reduceNum", table(
                [1, "kOrder", 0],
                [1, "kIce", 0],
                [1, "kBoss", 0],
                [1, "kWaterDig", 0],
                [1, "kFish", 0],
                [1, "kBlockCollection", 0],
                [1, "kPursue", 0]
            )]
        )]
    )]
)
module.exports = SchemeConfig